/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */
import Path from './Path'
import { point } from '../rect'

export default class Rectangle extends Path {

    constructor(frame) {
        super(frame)
        this._closed = true
        this._points = []
        this.layout()
    }

    get cacheKey() {
        let key = 'Rectangle-'
        key += this.frame.w + 'x'
        key += this.frame.h + '-'
        key += this.bounds.w + 'x'
        key += this.bounds.h + '-'
        key += this.fill + '-'
        key += this.stroke + '-'
        key += this.lineWidth + '-'

        return key
    }

    layout() {
        let lw = this.lineWidth / 2
        this.points = [
            point(lw, lw),
            point(this.frame.w-lw, lw),
            point(this.frame.w-lw, this.frame.h-lw),
            point(lw, this.frame.h-lw),
            point(lw, lw),
        ]
    }

}
